export interface PortalLanguage {
    id?: number;
    languageName: string;
    languageCode: string;
    countryImage: string;
    fileURL?: string;
}

export interface LanguagesApiData {
    languages: PortalLanguage[];
    userLanguage: string | null;
}

export const LANG_STORAGE_KEY = 'lang';
export const SESSION_LANG_KEY = 'activeLanguage';
export const LANGUAGE_FILE_URLS_KEY = 'tg.language.fileUrls';
export const USER_PREF_LANG_KEY = 'userPreferredLanguage';

/** Saved language on login response root (not nested under user). */
export function readLoginLanguage(response: unknown): string | null {
    const res = response as {
        user?: {
            userLanguage?: string | null;
        };
    };

    const value = res?.user?.userLanguage;

    return value != null && String(value).trim()
        ? String(value).trim()
        : null;
}

/** Saved language on getLanguagesList API response (if returned). */
export function readSavedUserLanguage(source: Record<string, unknown> | null | undefined): string | null {
    if (!source) {
        return null;
    }
    const value = source['LanguageCode'] ?? source['userLanguage'] ?? source['UserLanguage'] ?? null;
    return value != null && String(value).trim() ? String(value).trim() : null;
}
